import { memo } from 'react'

import { cn } from '@/shared/lib/cn'
import { RatingOrHotelType } from '@/shared/ui/rating/RatingOrHotelType'

interface OfferNamesProps {
	name: string
	stars: number
	address: string
	averageRate: string | number
	hotelType: string

	className?: string
}

/**
 * Show hotel/room name, address, stars and rating
 *
 * @author Ivan Shchedrovskyi
 */
export const OfferNames = memo(
	({
		name,
		stars,
		address,
		averageRate,
		hotelType,
		className
	}: OfferNamesProps) => {
		const averageRatingString = `${averageRate}/10`

		return (
			<div className={cn('flex flex-col items-start gap-4', className)}>
				<span className="ts-headline-4 w-full text-gray-500">
					<div className="flex items-center gap-4">
						<RatingOrHotelType
							stars={stars}
							hotelType={hotelType}
						/>

						<span
							className="overflow-x-hidden text-ellipsis md:whitespace-nowrap"
							title={name}
						>
							{name}
						</span>
					</div>
				</span>

				<span
					className="ts-4 w-full overflow-x-hidden text-ellipsis text-gray-500"
					title={address}
				>
					{address}
				</span>

				<span className="ts-3 text-gray-300">{averageRatingString}</span>
			</div>
		)
	}
)

OfferNames.displayName = 'OfferNames'
